import { IGlobalState } from '../states/GlobalState';
import { clearIdentityFromStorage } from '../types/auth';
import { GetConfiguration } from "../utils/config";
import { getHeaders, handleErrors } from './common';
import { ElabDto, ElabResponse } from "../dto/Dtos";

export const getElaborazioni = (prov: string, username: string, appId: number, global: IGlobalState) => {
    let fake_prov = (prov === undefined || prov === null) ? "44" : prov;
    const url = `${GetConfiguration().api_url}/consultools/elaborazioni/${fake_prov}/${username}/${appId}`
    console.log('getElaborazioni', url)
    return window.fetch(url, {
        method: 'GET',
        headers: getHeaders(global)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            console.log(`getElaborazioni("${username}") -> lette ${json.length} elaborazioni`);
            const rv = (json as ElabDto);
            return rv;
        })
        .catch(error => {
            console.log('getElaborazioni error:', error);
            throw new Error(error)
        });
}

export const getElaborazione = (prov: string, username: string, id: number, global: IGlobalState) => {
    let fake_prov = (prov === undefined || prov === null) ? "44" : prov;
    console.log('Sono in get elaborazioni');
    const url = `${GetConfiguration().api_url}/consultools/elaborazione/${fake_prov}/${username}/${id}`
    console.log('getElaborazione', url)
    return window.fetch(url, {
        method: 'GET',
        headers: getHeaders(global)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            console.log(`getElaborazione("${username}") -> lette ${json.length} elaborazioni`);
            const rv = (json as ElabResponse);
            console.log(rv);
            return rv;
        })
        .catch(error => {
            console.log('getElaborazione error:', error);
            throw new Error(error)
        });
}


export const saveElaborazione = (prov: string, username: string, nomeSimulazione: string, tipo: number, identificativo: string, piva: string, sede: string, json: string, global: IGlobalState) => {
    let fake_prov = (prov === undefined || prov === null) ? "44" : prov;
    const url = `${GetConfiguration().api_url}/consultools/elaborazioni/insert/${username}/${nomeSimulazione}/${fake_prov}/${tipo}/${identificativo}/${piva}/${sede}`
    console.log('saveElaborazione', url)
    return window.fetch(url, {
        method: 'POST',
        headers: getHeaders(global),
        body: JSON.stringify(json)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as ElabDto);
            return rv;
        })
        .catch(error => {
            console.log('saveElaborazione error:', error); throw new Error(error)
        });
}

export const sovrascriviElaborazione = (prov: string, username: string, id: number, json: string, global: IGlobalState) => {
    const url = `${GetConfiguration().api_url}/consultools/elaborazioni/update/${username}/${id}`
    console.log('sovrascriviElaborazione', url)
    return window.fetch(url, {
        method: 'POST',
        headers: getHeaders(global),
        body: JSON.stringify(json)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as ElabDto);
            return rv;
        })
        .catch(error => {
            console.log('sovrascriviElaborazione error:', error); throw new Error(error)
        });
}

export const updateElaborazione = (username: string, idSimulazione: number, json: string, global: IGlobalState) => {
    const url = `${GetConfiguration().api_url}/consultools/elaborazioni/update/${username}/${idSimulazione}`
    console.log('saveElaborazione', url)
    return window.fetch(url, {
        method: 'POST',
        headers: getHeaders(global),
        body: JSON.stringify(json)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('saveElaborazione error:', error);
            throw new Error(error)
        });
}

export const deleteElaborazione = (username: string, idSimulazione: number, global: IGlobalState) => {
    const url = `${GetConfiguration().api_url}/consultools/elaborazioni/delete/${username}/${idSimulazione}`
    console.log('deleteElaborazione', url)
    return window.fetch(url, {
        method: 'DELETE',
        headers: getHeaders(global),
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('deleteElaborazione error:', error);
            throw new Error(error)
        });
}

export const elaboraSchedaBudget = (username: string, json: string, global: IGlobalState) => {
    const url = `${GetConfiguration().api_url}/consultools/calcolaSchedaBudget/${username}`;
    console.log('elaboraSchedaBudget -> JSON -> ', json)
    return window.fetch(url, {
        method: 'POST',
        headers: getHeaders(global),
        body: JSON.stringify(json)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as ElabResponse);
            console.log(`elaboraSchedaBudget("${username}") -> response ${json}`);
            return rv;
        })
        .catch(error => {
            console.log('elaboraSchedaBudget error:', error);
            throw new Error(error)
        });
}

export const elaboraIForfetari = (username: string, json: string, global: IGlobalState) => {
    const url = `${GetConfiguration().api_url}/consultools/calcolaForfetari/${username}`;
    console.log('elaboraIForfetari -> JSON -> ', json)
    return window.fetch(url, {
        method: 'POST',
        headers: getHeaders(global),
        body: JSON.stringify(json)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as ElabResponse);
            console.log(`elaboraIForfetari("${username}") -> response ${json}`);
            return rv;
        })
        .catch(error => {
            console.log('elaboraIForfetari error:', error);
            throw new Error(error)
        });
}

export const elaboraConvSrl = (username: string, json: string, global: IGlobalState) => {
    const url = `${GetConfiguration().api_url}/consultools/calcolaSimulazioniSrl/${username}`;

    console.log('elaboraConvSrl -> JSON -> ', json)

    return window.fetch(url, {
        method: 'POST',
        headers: getHeaders(global),
        body: JSON.stringify(json)
    })
        .then(res => handleErrors(res, global))
        .then(res => res.json())
        .then(json => {
            const rv = (json as ElabResponse);
            console.log(`elaboraConvSrl("${username}") -> response ${json}`);
            return rv;
        })
        .catch(error => {
            console.log('elaboraConvSrl error:', error);
            throw new Error(error)
        });
}

export default {
    elaboraSchedaBudget: elaboraSchedaBudget,
    getElaborazioni: getElaborazioni,
    saveElaborazione: saveElaborazione,
}
